import Axios from 'axios';

const getDefaultState = () => {
  return {
    cities: [],
    citiesLoading: false,
    citiesLoaded: false
  };
};

const state = getDefaultState();

const getters = {
  getCitiesForSelect: state => {
    return state.cities.map(x => {
      return { value: x.id, text: x.name };
    });
  }
};

const mutations = {
  SET_CITIES: (state, payload) => {
    state.cities = payload;
  },

  SET_CITIES_LOADING: (state, payload) => {
    state.citiesLoading = payload;
  },

  SET_CITIES_LOADED: (state, payload) => {
    state.citiesLoaded = payload;
  },

  SET_CITY: (state, payload) => {
    const index = state.cities.findIndex(x => x.id === payload.cityId);

    state.cities[index] = {
      name: payload.name
    };
  },

  REMOVE_CITY: (state, cityId) => {
    const index = state.cities.findIndex(x => x.id === cityId);

    state.cities.splice(index, 1);
  },

  RESET_STATE_INDEX: state => {
    Object.assign(state, getDefaultState());
  }
};

const actions = {
  async fetchCities({ commit }) {
    commit('SET_CITIES_LOADED', false);
    commit('SET_CITIES_LOADING', true);

    await Axios.get('/1.0/spec-private/mars/miep/city')
      .then(response => {
        commit('SET_CITIES', response.data.data);
        commit('SET_CITIES_LOADED', true);
      })
      .finally(() => {
        commit('SET_CITIES_LOADING', false);
      });
  },

  async addCity({ commit, dispatch }, payload) {
    commit('SET_CITIES_LOADING', true);

    await Axios.post('/1.0/spec-private/mars/miep/city', payload)
      .then(() => {
        dispatch('fetchCities');
      })
      .finally(() => {
        commit('SET_CITIES_LOADING', false);
      });
  },

  async saveCity({ commit }, payload) {
    await Axios.put(`/1.0/spec-private/mars/miep/city/${payload.cityId}`, payload).then(() => {
      commit('SET_CITY', payload);
    });
  },

  async deleteCity({ commit }, cityId) {
    await Axios.delete(`/1.0/spec-private/mars/miep/city/${cityId}`).then(() => {
      commit('REMOVE_CITY', cityId);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
